import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { TradableWallet } from "@models/interfaces/tradable_wallet";
import { ModalService } from "@core-services/modal.service";
import { SendSelectNetworkComponent } from "@modules/main/components/step-summary/sending-modal/send-select-network/send-select-network.component";
import { PaymentsCryptocoin } from "@modules/+new/payments/shared-payments/entities/payments-cryptocoin.model";
import { Network } from "@modules/+new/payments/features/crypto-deposit/domain/entities/network.model";
import { SendWarningComponent } from "@modules/main/components/step-summary/sending-modal/send-warning/send-warning.component";

@Component({
	selector: "send-multiple-wallets-selection",
	templateUrl: "./send-multiple-wallets-selection.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SendMultipleWalletsSelectionComponent implements OnInit {
	@Input() walletList: TradableWallet[] = [];
	@Input() tradable: PaymentsCryptocoin = null;
	public availableNetworks: Network[] = [];
	public unavailableNetworks: Network[] = [];

	constructor(private readonly modalService: ModalService) {}

	ngOnInit(): void {
		if (this.tradable) {
			this.tradable?.networks?.forEach((val) =>
				(val.is_operational && val.is_withdraw_allowed
					? this.availableNetworks
					: this.unavailableNetworks
				).push(val)
			);
		}
	}

	public onBackButtonClick(): void {
		this.modalService.pop();
	}

	public onCancelButtonClick(): void {
		this.modalService.popAll();
	}

	public onSelectWallet($event: TradableWallet): void {
		if (this.availableNetworks.length === 1) {
			this.modalService
				.create(SendWarningComponent, {
					selectedCryptocoin: this.tradable,
					selectedNetwork: this.availableNetworks.pop(),
					walletId: $event.getId()
				})
				.present();
		} else {
			this.modalService
				.create(SendSelectNetworkComponent, {
					availableNetworks: this.availableNetworks,
					unavailableNetworks: this.unavailableNetworks,
					selectedCryptocoin: this.tradable,
					walletId: $event.getId()
				})
				.present();
		}
	}
}
